// extracted by mini-css-extract-plugin
export default {"cls1":"PaperContainer-cls1___28ca839429181f622f4","cls2":"PaperContainer-cls2___6a170213325f6b461d4 PaperContainer-cls1___28ca839429181f622f4"};